<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
        class="spinner">
        <g
            :clip-path="`url(#${clipPathId})`"
            data-figma-skip-parse="true">
            <foreignObject
                width="2125"
                height="2125"
                x="-1062.5"
                y="-1062.5"
                transform="rotate(90 0 16) scale(.016)"
                ><div
                    xmlns="http://www.w3.org/1999/xhtml"
                    :style="{
                        background:
                            'conic-gradient(from 90deg, rgba(255, 145, 51, 1) 0deg, rgba(255, 255, 255, 0.2) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: '1',
                    }"></div>
            </foreignObject>
        </g>
        <path
            d="M16 30.39c0 .89-.723 1.618-1.608 1.53a16 16 0 1 1 12.922-4.606l-2.277-2.277a12.78 12.78 0 1 0-10.643 3.641C15.276 28.79 16 29.5 16 30.39Z"
            data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":0.56862747669219971,"b":0.20000000298023224,"a":1.0},"position":0.0},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":0.20000000298023224},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":0.56862747669219971,"b":0.20000000298023224,"a":1.0},"position":0.0},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":0.20000000298023224},"position":1.0}],"transform":{"m00":1.9594349641362686e-15,"m01":-32.0,"m02":32.0,"m10":32.0,"m11":1.9594349641362686e-15,"m12":-1.9594349641362686e-15},"opacity":1.0,"blendMode":"NORMAL","visible":true}' />
        <defs>
            <clipPath :id="clipPathId">
                <path
                    d="M16 30.39c0 .89-.723 1.618-1.608 1.53a16 16 0 1 1 12.922-4.606l-2.277-2.277a12.78 12.78 0 1 0-10.643 3.641C15.276 28.79 16 29.5 16 30.39Z" />
            </clipPath>
        </defs>
    </svg>
</template>

<script setup lang="ts">
import { getCurrentInstance, computed } from 'vue';

const instance = getCurrentInstance();
// Generate a unique clipPath ID per component instance
const clipPathId = computed(() => `gradientspinner_${instance?.uid}_clip`);
</script>

<style scoped>
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.spinner {
    animation: spin 1s linear infinite;
}
</style>
